import { IconType } from "react-icons";
import {
  MdOutlineSearchOff,
  MdOutlineFolder,
  MdOutlinePerson,
  MdOutlineStoreMallDirectory,
  MdOutlineBuild,
  MdOutlineWorkOutline,
  MdLocationOn,
  MdContentPaste,
  MdFace,
} from "react-icons/md";

type EmptyStateType =
  | "generic"
  | "search"
  | "users"
  | "costumers"
  | "equipments"
  | "services"
  | "zones"
  | "reports"
  | "sectors"
  | "responsibles";

interface EmptyStateProps {
  type?: EmptyStateType;
  title?: string;
  description?: string;
  icon?: IconType;
}

const typeConfig: Record<
  EmptyStateType,
  { icon: IconType; title: string; description: string }
> = {
  generic: {
    icon: MdOutlineFolder,
    title: "Nada por aqui",
    description: "Nenhum registro foi encontrado.",
  },
  search: {
    icon: MdOutlineSearchOff,
    title: "Sem resultados",
    description: "Nenhum registro corresponde aos filtros aplicados.",
  },
  users: {
    icon: MdOutlinePerson,
    title: "Nenhum usuário",
    description: "Não há usuários cadastrados ainda.",
  },
  costumers: {
    icon: MdOutlineStoreMallDirectory,
    title: "Nenhum cliente",
    description: "Não há clientes cadastrados ainda.",
  },
  equipments: {
    icon: MdOutlineBuild,
    title: "Nenhum equipamento",
    description: "Não há equipamentos cadastrados ainda.",
  },
  services: {
    icon: MdOutlineWorkOutline,
    title: "Nenhum serviço",
    description: "Não há serviços cadastrados ainda.",
  },
  zones: {
    icon: MdLocationOn,
    title: "Nenhuma zona",
    description: "Não há zonas cadastradas ainda.",
  },
  reports: {
    icon: MdContentPaste,
    title: "Nenhum relatório",
    description: "Não há relatórios de visita técnica ainda.",
  },
  sectors: {
    icon: MdOutlineFolder,
    title: "Nenhum setor",
    description: "Não há setores cadastrados ainda.",
  },
  responsibles: {
    icon: MdFace,
    title: "Nenhum responsável",
    description: "Não há responsáveis cadastrados ainda.",
  },
};

export function EmptyState({
  type = "generic",
  title,
  description,
  icon,
}: EmptyStateProps) {
  const config = typeConfig[type];
  const Icon = icon || config.icon;
  const displayTitle = title || config.title;
  const displayDescription = description || config.description;

  return (
    <div className="flex flex-col items-center justify-center py-12 px-6">
      <div className="w-20 h-20 rounded-full bg-[#0085BD]/10 flex items-center justify-center mb-4">
        <Icon size={40} className="text-[#0085BD]" />
      </div>
      <h3 className="text-lg font-semibold text-[#0085BD] mb-2">
        {displayTitle}
      </h3>
      <p className="text-sm text-[#7FA5B2] text-center max-w-xs">
        {displayDescription}
      </p>
    </div>
  );
}
